var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleaner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e434d940-efe4-41dd-b26d-249dd16a6902",
    "data-name": "STO_015x120_car_care",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.39,24.14H73.55a5.51,5.51,0,0,0-5.47,5.47V41.82H89.86V29.49A5.4,5.4,0,0,0,84.39,24.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2,46.06H89.86V95.88H68.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.21,24.17H34.3a2.12,2.12,0,0,0-2.17,2v3.28A2.56,2.56,0,0,0,34.68,32a8.06,8.06,0,0,1,3,.5l-5.47,9.41a1.4,1.4,0,0,0,2.42,1.4L40,34.06a7.08,7.08,0,0,1,1.91,4.71v3H55.78V39.15c0-5.09,1.23-7.25,4-7.25,1.78,0,2-1.4,2-3.18V26.33C61.84,24.55,61,24.17,59.21,24.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4,46.06H42.55c-.76,0-.76.38-.76,2.55A54.87,54.87,0,0,1,39.5,62.05c-2.67,8-8.14,15.9-8.14,30,0,1.52.64,3.81,2.42,3.81H58.32c2.42,0,3.31-1.65,3.31-6.23,0-6.87-3.18-36.59-4.32-40.54C56.8,47.21,56.92,46.06,55.4,46.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaner);
export default __webpack_public_path__ + "static/media/cleaner.cc3d4e5d00ec48f84aac05886cfc2b75.svg";
export { ForwardRef as ReactComponent };